import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {LayoutSplashScreen} from '../../../../_heomoney/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {getUserByToken, refreshToken} from './_requests'
import {WithChildren} from '../../../../_heomoney/helpers'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'

import { useThemeMode } from '../../../../_heomoney/partials'

let temporizador = setInterval(() => {})
let settm = setInterval(() => {})

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    // console.log(auth);
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }
  //

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)

    const columnsToRemove = [
      "columnasCanales",
      "columnasTablaUsuario",
      "columnasTipoDocumento",
      "columnasTipoProductoFinanciero",
      "columnasPaises",
      "columnasBanco",
      "columnasConstante",
      "columnasOcupacion",
      "columnasMoneda",
      "columnasRoles",
      "columnasPreguntas_BO",
      "columnasWorkCenter",
      "columnasCuentasBancariasHeo_BO",
      "columnast100_BO",
      "columnasCodigoPromocional",
      "columnasRespuestasBO",
      "columnasCuentasHeoPF_BOP",
      "columnasUsuarioDocumentos",
      "columnasUsuarioAdjuntos",
      "columnasCanalPFBO",
      "columnasProductoFinancieroBO",
      "columnasCuentasBancariasODPF_BO",
      "columnasUsuarioRemesasOperaciones_BO",
      "columnasUsuarioCtasBancarias",
      "columnasRolUsuario",
      "columnasUsuarioTelefonos",
      "columnasCanalesPF_BO",
      "columnasCanalesBancoBO",
      "columnasUsuarioDireccion",
      "columnasCtasBancariasHeo_CanalBanco_Banco",
      "columnasCtasBancariasHeo_CanalBanco_CanalPF",
      "dataDirecciones",
      "datosPageTitle",
      "paisUsuario",
      "rolId",
      'prod_financiero',
      'banco',
      'moneda',
    ];
 
    columnsToRemove.forEach(column => {
      localStorage.removeItem(column);
    });

  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {

  const {mode} = useThemeMode() 

  const {auth, logout, setCurrentUser, saveAuth,currentUser} = useAuth()
  const didRequest = useRef(false)
  const intl = useIntl()
  const [count, setCount] = useState(30)
  // const [count1, setCount1] = useState(30)
  const [status, setStatus] = useState('stop')
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application

  useEffect(() => {
    setCount(30)
    if (status == 'inicio') {
      temporizador = setInterval(() => {
        setCount((count) => count - 1)
        //  console.log(count);
      }, 1000)
    }
    return () => {
      clearInterval(temporizador)
    }
  }, [status])

  useEffect(() => {
    // console.log(tiempoexpira);

    const requestUser = async (w_Token:string) => {
      try {
        if (!didRequest.current) {
          const {data} = await getUserByToken(w_Token,"backOffice")

          localStorage.removeItem('filtros_canales')
          localStorage.removeItem('filtros_cupones')
          localStorage.removeItem('filtros_t100')
          localStorage.removeItem('filtros_heo')
          localStorage.removeItem('filtros_preguntas')
          localStorage.removeItem('filtros_wc')
          localStorage.removeItem('filtros_roles')
          localStorage.removeItem('filtros_moneda')
          localStorage.removeItem('filtros_ocupacion')
          localStorage.removeItem('filtros_constante')
          localStorage.removeItem('filtros_bancos')
          localStorage.removeItem('filtros_pais')
          localStorage.removeItem('filtros_tipopf')
          localStorage.removeItem('filtros_tipodoc')
          localStorage.removeItem('filtros_usuarios')
          localStorage.removeItem('filtros_canal_canalpf')
          localStorage.removeItem('filtros_canalpf_heo')
          localStorage.removeItem('filtros_canal_canalbanco')
          localStorage.removeItem('filtros_canalbanco_heo')
          localStorage.removeItem('filtros_respuesta')
          localStorage.removeItem('filtros_rol_usuarios')
          localStorage.removeItem('filtros_pf')
          localStorage.removeItem('filtros_banco_canalpf')
          localStorage.removeItem('filtros_banco_cta')
          localStorage.removeItem('filtros_usuario_identificacion')
          localStorage.removeItem('filtros_usuario_cta')
          localStorage.removeItem('filtros_usuario_cta_destino')
          localStorage.removeItem('filtros_usuario_operacion')
          localStorage.removeItem('filtros_usuario_telf')
          localStorage.removeItem('filtros_usuario_adjuntos')
          localStorage.removeItem('filtros_usuario_direccion')

          console.log(data)
          if (data) {
            setCurrentUser(data)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }
    
    
    if (auth && auth.w_Token) {
      const usuarioactual = authHelper.getAuth()
      requestUser(auth.w_Token)
      console.log(usuarioactual);
      
      const evaluarFechaToken = () => {
        let today = new Date()
        let now = today.toLocaleString('en-GB')
        let nueva2 = ''
        let nueva3 = ''
          const fechaHora = auth.w_timeEnd.split(' ')
          const fecha = fechaHora[0].split('/').reverse().join('-')
          const hora = fechaHora[1]

          const nueva = new Date(`${fecha} ${hora}`)
          // console.log(nueva);
          nueva3 = nueva.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          })

          nueva.setSeconds(nueva.getSeconds() - 30)
          nueva2 = nueva.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          })
        

        let timeEndsincoma = nueva2.replace(',', '')

        let datesincoma = now.replace(',', '')
        let nueva3sincoma = nueva3.replace(',', '')

        // {REVISAR ÉSTA LÍNEA}
        const fechaHora1 = nueva3sincoma.split(' ')
          const fecha1 = fechaHora1[0].split('/').reverse().join('-')
          const hora1 = fechaHora1[1]

          const fecha_1 = new Date(`${fecha1} ${hora1}`)

        const fechaHora2 = datesincoma.split(' ')
          const fecha2 = fechaHora2[0].split('/').reverse().join('-')
          const hora2 = fechaHora2[1]

          const fecha_2 = new Date(`${fecha2} ${hora2}`)

        // console.log(fecha1,fecha2);
        // Restar las fechas y convertir el resultado a segundos
        const diffSegundos = (fecha_1.getTime() - fecha_2.getTime()) / 1000
        // console.log(diffSegundos);
        //nueva3sincoma es el tiempo de expiración
        //timeendsincoma es el tiempo de expiración 30 segundos antes
        //datesincoma es el tiempo de la maquina
        // console.log(datesincoma,timeEndsincoma,nueva3sincoma,diffSegundos);
        if (nueva3sincoma < datesincoma) {logout();clearInterval(intervalo)}

        if (timeEndsincoma == datesincoma || (diffSegundos > 0 && diffSegundos < 30)) {
          setStatus('inicio')

          Swal.fire({
            title: `Su sesión expirará en:`,
            // text: '¿Necesita mas tiempo para continuar?',
            html: `<b></b>
            <br/><br/>
            ¿Necesita mas tiempo para continuar?`,
            icon: 'warning',
            iconColor: 'red',
            // background: '#000000',
            background: mode === 'dark' ? `#000000` : undefined,

            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            timer: (diffSegundos + 2) * 1000,
            didOpen: () => {
              let valor = diffSegundos
              const b = Swal.getHtmlContainer()?.querySelector('b')
              intervalo = setInterval(() => {
                if (b) {
                  if (valor < 0) {
                    setCount(30)
              setStatus('stop')
                    logout()
                    
                  } else {
                    b.textContent = `${valor}`
                    valor--
                  }
                }
                //  console.log(count);
              }, 1000)
            },
            willClose: () => {
              console.log("hola");
              clearInterval(intervalo);
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              //refreshtoken
              //id, texto, token, tiempo de expiracion, tiempo de creación  
              //getuserbytoken
              const {data: auth1} = await refreshToken(usuarioactual?.w_Token,'backOffice')
              saveAuth(auth1)
                const {data: user} = await getUserByToken(auth1.w_Token,'backOffice')
              setCurrentUser(user)
              // console.log("Lógica para refrescar el token");
              Swal.fire({
                title: 'Renovando',
                text: 'Sigue disfrutando de HeoMoney',
                icon: 'success',
                // background: '#000000',
                background: mode === 'dark' ? `#000000` : undefined,
                showConfirmButton: false,
                timer: 2000,
              })
              setCount(30)
              setStatus('stop')
              clearTimeout(settm)
              clearInterval(intervalo)
              //window.location.reload()
            } else {
              logout()
              clearInterval(intervalo)
            }
          })
          clearInterval(intervalo)
        }
      }
      // llama a la función evaluarVariable cada segundo
      let intervalo = setInterval(evaluarFechaToken, 1000)
      return () => {
        clearInterval(intervalo);
      };
    }else {
      setCount(30)
      setStatus('stop')
      logout()
      setShowSplashScreen(false)
    }
    
    // eslint-disable-next-line
  }, [auth])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}